import type { RuoloDTO } from '@/models/dto/utente/ruolo-dto'
import { mapToRole, mapToRuoliDTO } from '@/models/mappers/user/role-mapper'
import type { Role } from '@/models/types/user/role'
import type { FetchOptionsType } from './api'
import { deleteJsonRequest, getRequest, postJsonRequest, putJsonRequest } from './make-request'

type RoleCrudType = (fetchOptions?: FetchOptionsType) => {
    getOne: (id: string) => Promise<Role>
    getMany: () => Promise<Role[]>
    post: (role: Omit<Role, 'id'>) => Promise<Role>
    put: (role: Role) => Promise<Role>
    delete: (id: string) => Promise<void>
}

const ROLE_URL =
    typeof window === 'undefined' ? `${process.env.API_URL}/api/v1/Ruoli` : `${location.origin}/api/v1/Ruoli`
const ROLE_TAG = 'role'

const roleCRUD: RoleCrudType = (fetchOptions) => ({
    getOne: async (id) => {
        const url = new URL(`${ROLE_URL}/${id.toString()}`)
        const ruoliDTO = await getRequest<RuoloDTO>({ url, next: { tags: [ROLE_TAG] }, ...fetchOptions })
        const role = mapToRole(ruoliDTO) as Role
        return role
    },
    getMany: async () => {
        const url = new URL(ROLE_URL)
        const ruoliDTO = await getRequest<RuoloDTO[]>({ url, next: { tags: [ROLE_TAG] }, ...fetchOptions })
        const roles = ruoliDTO.map((ruolo) => mapToRole(ruolo)) as Role[]
        return roles
    },
    post: async (role) => {
        const ruoliDTO = mapToRuoliDTO(role)
        const url = new URL(ROLE_URL)
        const ruoliDTOResponse = await postJsonRequest<RuoloDTO>({ url, body: ruoliDTO, ...fetchOptions })
        const roleResult = mapToRole(ruoliDTOResponse) as Role
        return roleResult
    },
    put: async (role) => {
        const ruoliDTO = mapToRuoliDTO(role)
        const url = new URL(ROLE_URL)
        const ruoliDTOResponse = await putJsonRequest<RuoloDTO>({ url, body: ruoliDTO, ...fetchOptions })
        const roleResult = mapToRole(ruoliDTOResponse) as Role
        return roleResult
    },
    delete: async (id) => {
        const url = new URL(`${ROLE_URL}/${id.toString()}`)
        await deleteJsonRequest({ url, ...fetchOptions })
    },
})

export { roleCRUD, type RoleCrudType }
